import React from 'react';
import PropTypes from 'prop-types';
import ServerSideTableAdvanced from './Advanced';

const propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()),
  query: PropTypes.shape().isRequired,
  onFetch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  scopedSlots: PropTypes.shape(),
};

const defaultProps = {
  data: [],
  loading: false,
  scopedSlots: {},
};

const ServerSideTableSimple = ({
  data, query, onFetch, loading, scopedSlots, ...props
}) => {
  const [firstRender, setFirstRender] = React.useState(true);

  const onTableFilterChange = (v) => {
    if (firstRender) return;
    onFetch({
      ...query,
      search: v,
      page: 1,
    });
  };

  const onPageChange = (v) => {
    if (firstRender) return;
    onFetch({
      ...query, page: v,
    });
  };

  const onSorterChange = (sortV, orderV) => {
    if (firstRender) return;
    onFetch({
      ...query, sort: sortV, order: orderV,
    });
  };

  const onItemsPerPageChange = (v) => {
    if (firstRender) return;
    onFetch({
      ...query, perPage: v,
    });
  };

  React.useEffect(() => {
    setFirstRender(false);
  }, []);

  return (
    <ServerSideTableAdvanced
      currentPage={query.page}
      pages={query.lastPage}
      data={data}
      sorter={{ sort: query.sort, order: query.order }}
      onPageChange={onPageChange}
      onTableFilterChange={onTableFilterChange}
      onSorterChange={onSorterChange}
      onItemsPerPageChange={onItemsPerPageChange}
      tableFilterValue={query.search}
      itemsPerPageValue={query.perPage}
      loading={loading}
      scopedSlots={scopedSlots}
      {...props}
    />

  );
};

ServerSideTableSimple.propTypes = propTypes;
ServerSideTableSimple.defaultProps = defaultProps;

export default ServerSideTableSimple;
